import { ApiFunc, getInstance } from '@src/helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const helpDeskTicketsAll: ApiFunc<`${typeof API.HELP_DESK_TICKETS_ALL}`, 'get'> = data =>
  instance.get(API.HELP_DESK_TICKETS_ALL, {
    params: data,
  })

export const helpDeskTicketsList: ApiFunc<`${typeof API.HELP_DESK_TICKETS}`, 'get'> = data =>
  instance.get(API.HELP_DESK_TICKETS, {
    params: data,
  })

export const helpDeskTicketsCreate: ApiFunc<`${typeof API.HELP_DESK_TICKETS}`, 'post'> = data =>
  instance.post(API.HELP_DESK_TICKETS, data)

export const helpDeskTicketsOwn: ApiFunc<`${typeof API.HELP_DESK_TICKETS_OWN}`, 'get'> = data =>
  instance.get(API.HELP_DESK_TICKETS_OWN, {
    params: data,
  })

export const helpDeskTickets: ApiFunc<`${typeof API.HELP_DESK_TICKETS}{id}`, 'get'> = data =>
  instance.get(`${API.HELP_DESK_TICKETS}${data.id}`, {
    params: dissoc('id', data),
  })

export const helpDeskTicketsDelete: ApiFunc<`${typeof API.HELP_DESK_TICKETS}{id}`, 'delete'> = data =>
  instance.delete(`${API.HELP_DESK_TICKETS}${'id' in data ? prop('id', data) : data?.name}`)

export const helpDeskTicketsUpdate: ApiFunc<`${typeof API.HELP_DESK_TICKETS}`, 'put'> = data =>
  instance.put(API.HELP_DESK_TICKETS, data)
